import { render } from "./ScrollPane.vue?vue&type=template&id=f629e26c&scoped=true&ts=true"
import script from "./ScrollPane.vue?vue&type=script&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&lang=ts"

import "./ScrollPane.vue?vue&type=style&index=0&id=f629e26c&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjjc-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f629e26c"]])

export default __exports__